import { Routes, Route, Navigate } from "react-router-dom";
import CustomProjectHome from "./pages/CustomProjectHome";
import { CUSTOM_PROJECT_ROUTE } from "./routes";

/**
 * Root shell for the custom project. Use nested routes here as the project grows.
 * Parent `App.jsx` should mount this at `CUSTOM_PROJECT_ROUTE` with a trailing `/*`.
 */
export default function CustomProjectShell() {
  return (
    <Routes>
      <Route index element={<CustomProjectHome />} />
      <Route path="*" element={<Navigate to={CUSTOM_PROJECT_ROUTE} replace />} />
    </Routes>
  );
}
